import { drawRoundedPolygon, fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    topSlantRatio: 0.2
};
/**
 * Represents a Manual Input/Output shape, a flowchart element used to indicate
 * manual input or output operations. Extends Rectangle with a slanted top edge.
 */
export class ManualInputOutput extends Rectangle {
    /**
     * Creates a new ManualInputOutput instance.
     * @param options - Configuration options for the manual input/output shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /**
     * @hidden
     * Draws the manual input/output shape path as a quadrilateral with slanted top.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const { topSlantRatio, cornerRadius } = this.options;
        const topSlant = height * topSlantRatio;
        const points = [
            { x: 0, y: topSlant },
            { x: width, y: 0 },
            { x: width, y: height },
            { x: 0, y: height }
        ];
        drawRoundedPolygon(drawingElement, points, cornerRadius);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
